import { Box, Flex, Grid } from '@chakra-ui/react';
import { node, string } from 'prop-types';

import bookingsLogoDesktop from '@/assets/bookings-logo-desktop.svg';

export function DesktopWideLayout({ children, 'data-testid': dataTestId }) {
  return (
    <Flex
      data-testid={dataTestId}
      data-testname="DesktopWideLayout"
      direction="column"
      justify="flex-start"
      align="center"
      h="100%"
      overflowY="auto"
    >
      <Grid
        templateColumns="1fr 760px 1fr"
        gap="70px"
        pt="20px"
        pb={4}
        h="100%"
      >
        <img src={bookingsLogoDesktop} alt="CatchApp Bookings Logo" />
        <Box boxShadow="md" p={12} w="100%">
          {children}
        </Box>
      </Grid>
    </Flex>
  );
}

DesktopWideLayout.propTypes = {
  'data-testid': string,
  children: node,
};

DesktopWideLayout.defaultProps = {
  'data-testid': undefined,
  children: undefined,
};
